import { ArchErrors, TeethArchEnum, ToothErrors } from "@jasper/client-models";

export default {
  common: {
    errorOccurred: "An error occurred. Please try again.",
    errorNotificationTitle: "Error",
    errorNotificationMessage: "An error occurred. Please try again.",
    confirm: "Confirm",
    cancel: "Cancel",
    productNotFound: "Product not found for this configuration.",
  },
  orderDescription: {
    productsCount_one: "{{count}} prosthesis",
    productsCount_other: "{{count}} prostheses",
    defaultTitle: "Order",
  },
  shadeTypes: {
    VITA_CLASSIC: "Vita Classical",
    VITA_3D_MASTER: "Vita 3D Master",
    CHROMASCOP: "Chromascop",
    SR_VIVODENT_SPE: "Sr Vivodent Spe",
  },
  arches: {
    [TeethArchEnum.MAXILLARY]: "Maxillary",
    [TeethArchEnum.MANDIBULAR]: "Mandibular",
  },
  steps: {
    arch: {
      title: "Arch selection",
      hint: "Click a tooth to select its whole arch. Select both arches to create one product per arch.",
      errors: {
        [ArchErrors.NO_ARCH_SELECTED]: "You must select at least one arch.",
        [ArchErrors.INCOMPLETE_ARCH]: "The selected arch is incomplete.",
      },
    },
    teeth: {
      title: "Teeth selection",
      noToothSelected: "No tooth selected",
      bulk: {
        hint: "Select several teeth to create one prosthesis per tooth.",
      },
      errors: {
        [ToothErrors.INVALID_TOOTH]: "The selected tooth is not valid.",
        [ToothErrors.NON_UNIQUE_TEETH]:
          "You can only select one tooth for this type of prosthesis.",
        [ToothErrors.NON_ADJACENT_TEETH]:
          "The selected teeth must be adjacent.",
        [ToothErrors.NON_MULTI_TEETH]: "You must select at least two teeth.",
        [ToothErrors.NO_TOOTH_SELECTED]: "You must select at least one tooth.",
        unexpected: "An unexpected error occurred. Please try again.",
      },
    },
    adjacentTeeth: {
      labels: {
        element_one: "element",
        element_other: "elements",
      },
    },
    waxUpType: {
      title: "Wax-up type",
      NUMERICAL: "Numerical",
      PHYSICAL: "Physical",
      NUMERICAL_AND_PHYSICAL: "Numerical and physical",
    },
    inlayCore: {
      title: "Post and core characteristics",
      productNotFound: "No product found for this configuration.",
      choicesUnavailable:
        "Materials and scan posts could not be loaded. Please try again.",
    },
    inlayCoreCrown: {
      title: "Crown",
      createCrownLabel: "Also make the crown on this post and core",
      createCrownDescription: "Uncheck to order the post and core only",
    },
    implantConnection: {
      title: "Implant connection",
      productNotFound: "No product found for this configuration.",
      choicesUnavailable:
        "Implant references could not be loaded. Please try again.",
    },
    abutment: {
      title: "Abutment",
    },
    implantRetention: {
      title: "Retention mode",
    },
  },
  bulk: {
    arches: {
      MAXILLARY: "maxillary",
      MANDIBULAR: "mandibular",
    },
    errorNotificationTitle: "Bulk creation failed",
    errorNotificationMessage:
      "An error occurred while updating the prostheses. Please try again.",
  },
};
